var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivityLogActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.58887 5.75C8.17887 5.75 7.83887 5.41 7.83887 5V2C7.83887 1.59 8.17887 1.25 8.58887 1.25C8.99887 1.25 9.33887 1.59 9.33887 2V5C9.33887 5.41 8.99887 5.75 8.58887 5.75Z",
    fill: "#5E1899"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5889 5.75C16.1789 5.75 15.8389 5.41 15.8389 5V2C15.8389 1.59 16.1789 1.25 16.5889 1.25C16.9989 1.25 17.3389 1.59 17.3389 2V5C17.3389 5.41 16.9989 5.75 16.5889 5.75Z",
    fill: "#5E1899"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5889 11.75H7.58887C7.17887 11.75 6.83887 11.41 6.83887 11C6.83887 10.59 7.17887 10.25 7.58887 10.25H15.5889C15.9989 10.25 16.3389 10.59 16.3389 11C16.3389 11.41 15.9989 11.75 15.5889 11.75Z",
    fill: "#5E1899"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5889 15.75H7.58887C7.17887 15.75 6.83887 15.41 6.83887 15C6.83887 14.59 7.17887 14.25 7.58887 14.25H12.5889C12.9989 14.25 13.3389 14.59 13.3389 15C13.3389 15.41 12.9989 15.75 12.5889 15.75Z",
    fill: "#5E1899"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5889 22.75H9.58887C3.96887 22.75 2.83887 20.1 2.83887 15.82V9.65C2.83887 4.91 4.43887 2.98 8.54887 2.75H16.5889C20.7389 2.98 22.3389 4.91 22.3389 9.65V16C22.3389 16.41 21.9989 16.75 21.5889 16.75C21.1789 16.75 20.8389 16.41 20.8389 16V9.65C20.8389 5.29 19.3889 4.41 16.5489 4.25H8.58887C5.78887 4.41 4.33887 5.29 4.33887 9.65V15.82C4.33887 19.65 5.06887 21.25 9.58887 21.25H15.5889C15.9989 21.25 16.3389 21.59 16.3389 22C16.3389 22.41 15.9989 22.75 15.5889 22.75Z",
    fill: "#5E1899"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5889 22.75C15.4889 22.75 15.3989 22.73 15.2989 22.69C15.0189 22.57 14.8389 22.3 14.8389 22V19C14.8389 16.58 16.1689 15.25 18.5889 15.25H21.5889C21.8889 15.25 22.1689 15.43 22.2789 15.71C22.3989 15.99 22.3289 16.31 22.1189 16.53L16.1189 22.53C15.9789 22.67 15.7889 22.75 15.5889 22.75ZM18.5889 16.75C17.0089 16.75 16.3389 17.42 16.3389 19V20.19L19.7789 16.75H18.5889Z",
    fill: "#5E1899"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityLogActive);
export default __webpack_public_path__ + "static/media/activity-log-active.f38976ae6020272735d7e8863ac3883e.svg";
export { ForwardRef as ReactComponent };